import {Icon, Typography} from '@bonprix/design-system';
import {ActiveUnderlineWrapper} from './ActiveUnderlineWrapper.jsx';
import Device from '@core/scripts/components/device';
import Landmark from '@core/scripts/components/landmark-adapter';
import {useContext, useRef} from 'react';
import {NavigationFocusContext} from '@header/scripts/components/context/NavigationFocusContext.jsx';

export default function SecondLevelItem({
    navigationItem,
    setCurrentHoveredItemId,
    currentHoveredItemId,
    thirdLevelEmpty = false,
}) {
    const {toThirdLevel} = useContext(NavigationFocusContext);
    const nextButtonRef = useRef(null);

    const isTouchDevice = useRef(Device.isTouch() || matchMedia('(hover: none)').matches);
    const isActive = (!currentHoveredItemId && navigationItem.active) || currentHoveredItemId === navigationItem.id;
    const titleColor = navigationItem.fontColor || 'primary';

    function updateHoveredItem() {
        setCurrentHoveredItemId(navigationItem.id);
    }

    const handlePointerEnter = () => {
        if (!isTouchDevice.current) {
            updateHoveredItem();
        }
    };

    const handleOnClick = (e) => {
        if (isTouchDevice.current && !isActive) {
            e.preventDefault();
            updateHoveredItem();
            return;
        }
        const naviLmValue = `hn\\${navigationItem.id}\\\\`;
        Landmark.sendUserInterfaceLandmark({navi: naviLmValue});
    };

    const handleFocus = () => {
        updateHoveredItem();
    };

    // the third level is only entered on purpose, never by simply tabbing on
    const handleKeyDown = (e) => {
        if (e.key !== 'ArrowRight' || thirdLevelEmpty) {
            return;
        }

        e.preventDefault();
        toThirdLevel(nextButtonRef.current);
    };

    return (
        <div
            onPointerEnter={handlePointerEnter}
            onKeyDown={handleKeyDown}
            className={`navigation__item -level:second ${isActive ? 'is-hovered' : ''}`}
        >
            <div className="flex flex-col w-full static">
                <a
                    href={navigationItem.url}
                    className={'navigation__item-label'}
                    onClick={handleOnClick}
                    onFocus={handleFocus}
                >
                    <ActiveUnderlineWrapper
                        navigationItem={navigationItem}
                        currentHoveredItemId={currentHoveredItemId}
                        isShopActive={true}
                    >
                        <Typography color={titleColor} variant="bonprix-h6" component={'span'}>
                            {navigationItem.title}
                        </Typography>
                    </ActiveUnderlineWrapper>
                </a>
                {!thirdLevelEmpty && (
                    <button
                        ref={nextButtonRef}
                        className={'navigation__next-btn'}
                        onClick={(e) => {
                            toThirdLevel(e.currentTarget);
                        }}
                        onFocus={handleFocus}
                        aria-label={`${navigationItem.title}, Unterkategorien anzeigen`}
                        aria-haspopup="true"
                        aria-expanded={!!currentHoveredItemId}
                        aria-controls="desktop-navigation-third-level"
                    >
                        {isActive && <Icon variant="back" className="icon" />}
                    </button>
                )}
            </div>
        </div>
    );
}
